<template>
  <div id="rates-create">
    <PmwTopProgress :start="loading" :done="!loading" color="#53B483" />

    <SidebarLayout3 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>
            Ações da página
          </Heading>

          <Button
            v-if="routeType"
            :disabled="disableSaveButton || loading"
            :tooltipText="
              'Para salvar, preencha os campos obrigatórios sinalizados com *'
            "
            class="page-actions--button"
            @click="createRate()"
          >
            Salvar
          </Button>
          <Button
            v-else
            :disabled="disableSaveButton || loading"
            :tooltipText="
              'Para salvar, preencha os campos obrigatórios sinalizados com *'
            "
            class="page-actions--button"
            @click="editRate()"
          >
            Salvar
          </Button>
          <Button
            layout="outline"
            class="page-actions--button"
            @click="$router.push({ name: 'extras-bundler-list' })"
          >
            Voltar sem salvar
          </Button>
          <Button
            v-if="!routeType"
            variation="error"
            class="page-actions--button"
            @click.stop.prevent="deleteModal($route.params.id)"
          >
            Excluir
          </Button>
        </SidebarBlock>
      </template>

      <!-- FORMULÁRIO -->
      <template #content>
        <span class="form">
          <FormInput
            v-model="nome"
            :error="error.nome"
            :required="true"
            :showErrorFeedbackMessage="true"
            label="Nome do agrupador"
            placeholder="Insira o nome do agrupador"
            class="text-input--email large"
          />
        </span>

        <span class="form">
          <PmwSelectionBoxScroll
            v-model="selectedItems"
            :list="formatProductItems"
            :buffer="0"
            comparisonKey="codigo"
            placeholder="Busque pelo nome do produto/serviço"
            selectedPlaceholder="Busque pelo nome do produto/serviço selecionado"
            titleFirstBox="Adicionar produto/serviço do grupo"
            titleSecondBox="Produtos/serviços selecionados"
            class="scroll-container"
            @searchItem="searchText = $event"
          >
            <template #recycle-selection-box--empty-text-selection>
              <Paragraph
                v-if="!loadOptions"
                fontSize="small"
                class="empty-text"
              >
                Nenhum produtos ou serviços encontrado.
              </Paragraph>
              <p v-else-if="loadOptions" class="pmw-loader"></p>
            </template>
          </PmwSelectionBoxScroll>

          <hr class="horizontal-line" />
        </span>

        <!-- FOOTER -->
        <span class="bottom-buttons">
          <Button
            layout="outline"
            class="bottom-buttons--return"
            @click="$router.push({ name: 'extras-bundler-list' })"
          >
            Voltar sem salvar
          </Button>
          <Button
            v-if="routeType"
            :disabled="disableSaveButton || loading"
            :tooltipText="
              'Para salvar, preencha os campos obrigatórios sinalizados com *'
            "
            :popperStrategy="'auto'"
            class="bottom-buttons--save"
            @click="createRate()"
          >
            Salvar
          </Button>
          <Button
            v-else
            :disabled="disableSaveButton || loading"
            class="bottom-buttons--save"
            @click="editRate()"
          >
            Salvar
          </Button>
        </span>
      </template>
    </SidebarLayout3>

    <!-- MODAL DELEÇÃO -->
    <AlertModal
      v-model="showDeleteModal"
      :buttonClose="true"
      title="Excluir agrupador de produtos e serviços"
      @alert-modal-cancel="cancelDisable()"
      @alert-modal-confirm="disableRate()"
    >
      <template #text>
        Ao excluir esse agrupador, não será mais possível visualizar as
        informações contidas nele de forma compilada em relatórios. <br />
        Tem certeza de que quer fazer isso?
      </template>
    </AlertModal>
  </div>
</template>

<script>
/** Componentes da lib */
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import { PmwSelectionBoxScroll } from '@solucoes/components-lib-tmp/src/components/patterns/PmwSelectionBox'
import PmwTopProgress from '@solucoes/components-lib-tmp/src/components/elements/PmwTopProgress'
import { removeStringAccents } from '@/helpers/string'

/** Imports do projeto */
import SidebarLayout3 from '@/layouts/SidebarLayout3'

export default {
  name: 'rateBundlerCreate',
  components: {
    Button,
    FormInput,
    Heading,
    SidebarLayout3,
    AlertModal,
    SidebarBlock,
    PmwSelectionBoxScroll,
    PmwTopProgress,
    Paragraph
  },
  data() {
    return {
      options: [] /** Opções de produtos e serviços */,
      selectedItems: [] /** Array de itens selecionados */,
      nome: '' /** Nome do grupo */,
      breadcrumb: [
        {
          label: 'Configurações',
          url: '/',
          isSpa: true
        },
        {
          label: 'Agrupador de produtos e serviços',
          url: '/Admin/v2/agrupador-produtos'
        },
        {
          label: 'Criar novo agrupador de produtos e serviços'
        }
      ],
      /** Guarda tipo de página (Edição/Criação)  */
      routeType: '',
      /** Título da página  */
      pageTitle: null,
      /** Exibição da modal de deleção */
      showDeleteModal: false,
      /** Guarda Id para deleção */
      rateDelete: null,
      /** Guarda Id do extra */
      rateId: null,
      /** Controle de erro */
      error: {
        nome: false
      },
      firstLevelList: null,
      childValue: null,

      productsItems: [],
      searchText: null,
      updateParts: {
        viewStartIdx: 0,
        viewEndIdx: 0,
        visibleStartIdx: 0,
        visibleEndIdx: 0
      },
      isSearch: false,
      currentPage: null,
      loadOptions: false,
      loading: false,

      stopPagination: false
    }
  },
  computed: {
    formatProductItems() {
      return this.searchedItem.map((item) => {
        return {
          descricao: `${item.codigo} - ${item.nome}`,
          codigo: item.codigo
        }
      })
    },

    disableSaveButton() {
      if (
        this.nome !== '' &&
        this.selectedItems.length !== 0 &&
        !this.loading
      ) {
        return false
      }
      return true
    },

    /** Faz o filtro dos itens */
    searchedItem() {
      if (!this.searchText) {
        return this.productsItems
      }

      const search = removeStringAccents(this.searchText).toLowerCase()

      return this.productsItems.filter((item) => {
        const itemName = removeStringAccents(item.nome).toLowerCase()

        return itemName.includes(search)
      })
    }
  },
  watch: {
    /** Controle de erro de nome */
    nome: {
      handler: function() {
        if (this.nome !== '') {
          this.error.nome = false
        } else {
          this.error.nome = true
        }
      },
      deep: true
    }
  },

  created() {
    /** Get de métodos */
    this.pageType()
    this.getProducts()
  },

  methods: {
    /** Verifica se é edição ou criação */
    pageType() {
      if (this.$route.name === 'extras-bundler-create') {
        this.routeType = true
        this.pageTitle = 'Criar novo agrupador de produtos e serviços'
      } else {
        this.routeType = false
        this.getSingleRate()
      }
    },

    /** Retorna dados do usuário */
    getSingleRate() {
      this.$productsAndServicesBundler
        .get(this.$route.params.id)
        .then(({ data }) => {
          /** Temporário */
          this.nome = data.nome
          const returnData = data.produtos

          returnData.forEach((dados) => {
            const data = {
              codigo: dados.codigo,
              descricao: dados.codigo + ' - ' + dados.nome.trim(),
              ativo: true,
              text: dados.codigo + ' - ' + dados.nome.trim(),
              id: dados.codigo
            }

            this.selectedItems.push(data)
          })

          this.breadcrumb = [
            {
              label: 'Configurações'
            },
            {
              label: 'Agrupador de produtos e serviços',
              url: '/Admin/v2/agrupador-produtos'
            },
            {
              label: `Editando ${this.nome}`
            }
          ]
          this.pageTitle = 'Editando ' + this.nome
        })
    },

    /** Edição de usuário */
    editRate() {
      if (this.nome === null && !this.selectedItems.length) {
        return this.$bus.$emit('show-alert-chip', {
          message: 'Por favor, preencha todos os campos obrigatórios'
        })
      }

      const productsIDs = this.selectedItems.map((item) => {
        return parseInt(item.codigo)
      })

      this.$productsAndServicesBundler
        .put(parseInt(this.$route.params.id), this.nome, productsIDs)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de produtos e serviços editado com sucesso'
          })
          this.$router.push({ name: 'extras-bundler-list' })
        })
        .catch((err) => {
          this.$bus.$emit('show-alert-chip', {
            message: err.messages[0]
          })
        })
    },

    /** Cria uma nova receita */
    createRate() {
      if (this.nome === null && !this.selectedItems.length) {
        return this.$bus.$emit('show-alert-chip', {
          message: 'Por favor, preencha todos os campos obrigatórios'
        })
      }

      /** Tratamendo de dados para envio de produtos */
      const productsIDs = this.selectedItems.map((item) => {
        return parseInt(item.codigo)
      })

      this.$productsAndServicesBundler
        .post(this.nome, productsIDs)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de produtos e serviços criado com sucesso'
          })
          this.$router.push({ name: 'extras-bundler-list' })
        })
        .catch((err) => {
          this.$bus.$emit('show-alert-chip', {
            message: err.messages[0]
          })
        })
    },

    /** Chamada para deletar usuário */
    disableRate() {
      this.$rate
        .disableRate({ agrupadores: [parseInt(this.$route.params.id)] })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de produtos e serviços excluido com sucesso'
          })
          this.$router.push({ name: 'extras-bundler-list' })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativar agrupador de produtos e serviços'
          })
        })
    },

    /** Retorna os produtos elegíveis */
    async getProducts() {
      if (this.stopPagination) {
        this.loadOptions = false
        this.loading = false
        return
      }

      this.loading = true

      await this.$productsAndServicesBundler
        .getProducts()
        .then(async ({ data }) => {
          if (!data.length) this.stopPagination = true

          await data.forEach((item) => {
            const itemExists = this.productsItems.find(
              (existingItem) => existingItem.codigo === item.codigo
            )

            if (!itemExists) {
              this.productsItems.push(item)
            }
          })
        })
        .finally(() => {
          this.loading = false
          this.loadOptions = false
        })
    },

    /** Controle de deleção */
    deleteModal(rateId) {
      this.showDeleteModal = true
      this.rateDelete = rateId
    },

    /** Controle de cancelamento de deleção */
    cancelDisable() {
      this.showDeleteModal = false
      this.rateDelete = null
    }
  }
}
</script>

<style lang="scss" scoped>
.pmw-loader {
  @include pmw-loader();
}

.large {
  width: 270px;
}
.medium {
  width: 150px;
}
.small {
  width: 56px;
}

.horizontal-line {
  margin: 0 auto 10px;
}

.text-input {
  &--email {
    margin-top: 37px;
    margin-right: 35px;
  }
  &--limit {
    width: 141px;
  }
}

.form {
  display: block;
  gap: 20px;
  margin-bottom: 30px;
}

.bottom-buttons {
  display: flex;
  justify-content: space-between;
  &--return,
  &--save {
    z-index: 2;
    width: 215px;
  }
}

::v-deep .lb-breadcrumb--link:nth-child(2) {
  pointer-events: none;
}

::v-deep .content--white_card {
  padding: {
    top: 20px;
  }
}

.page-actions {
  padding-top: 50px;
  &--button {
    width: 100%;
    cursor: pointer;

    & + .page-actions--button {
      margin-top: 10px;
    }
  }
}

.empty-text {
  color: pmw-colors('grey-60');
}
</style>
